module.exports = __webpack_public_path__ + "static/media/title.3add3a53.png";